<template>
	<div class="shop-total">
		<img src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/pc/dyt_pc_shop_bg.png?v=2" class="bg" />
		<div class="containers">
			<div class="content" v-loading="loading">
				<div class="tab">
					<img v-if="current == 0"
						:src="'https://jiaqi.obs.cn-north-1.myhuaweicloud.com/pc/dyt_pc_shop_btn1.png?v='+Math.random()"
						alt="">
					<img v-if="current == 1"
						:src="'https://jiaqi.obs.cn-north-1.myhuaweicloud.com/pc/dyt_pc_shop_btn2.png?v='+Math.random()"
						alt="">
					<span class="tabs">
						<label for="" @click="tabChange(0)"></label>
						<label for="" @click="tabChange(1)"></label>
					</span>

				</div>
				<div :class="current == 1?'listCon':'listConOne'">
					<div v-for="(item, index) in list" :key="item.id" class="item">
						<div class="itemLon-show">
							<el-image class="banner"
								:src="item.imgUrl != null?item.imgUrl:'https://jiaqi.obs.cn-north-1.myhuaweicloud.com/dytmini/dyt_shop_head.jpg'"
								:preview-src-list="[item.imgUrl != null?item.imgUrl:'https://jiaqi.obs.cn-north-1.myhuaweicloud.com/dytmini/dyt_shop_head.jpg']" />
							</el-image>
						</div>
						<div class="itemLon">
							<div class="itemLon-one">
								<span> {{item.smallarea}} </span>
								<p class="line">|</p>
								<label for=""> {{item.name}} </label>
							</div>
							<div class="address" v-if="current !== 1">
								<img class="icon1"
									src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/dytmini/dyt_shop_loc_icon.png"
									alt="">
								<label for="">{{ item.address }}</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bottom">
				<img @click="clickLastPage" class="last-btn"
					src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/pc/dyt_pc_last_page.png" />
				<img @click="clickNextPage" class="next-btn"
					src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/pc/dyt_pc_next_page.png" />
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getShopList,
		getShopLists
	} from "@/api/index";
	export default {
		data() {
			return {
				loading: true,
				page: 1,
				list: [],
				current: 0
			};
		},
		created() {
			this.connectLists();
		},
		methods: {
			setDefaultImage(e) {
				e.target.src = "https://jiaqi.obs.cn-north-1.myhuaweicloud.com/dytmini/dyt_shop_head.jpg"
			},
			tabChange(e) {
				this.current = e
				this.page = 1
				this.list = []
				if (e == 1) {
					this.connectList();
				} else {
					this.connectLists();
				}
			},
			clickLastPage() {
				if (this.page > 1) {
					this.page -= 1;
				}
				if (this.current == 1) {
					this.connectList();
				} else {
					this.connectLists();
				}
			},
			clickNextPage() {
				if (this.list.length % 10 != 0) return;
				this.page += 1;
				if (this.current == 1) {
					this.connectList();
				} else {
					this.connectLists();
				}
			},
			connectList() {
				this.loading = true;
				var orgID = this.$app == "dy" ? 461 : 559
				getShopList(this.page, orgID).then((res) => {
					this.list = [];
					if (res.objects != null) {
						// res.objects.forEach((element) => {
						// 	let ary = element.areaInformationName.split("-");
						// 	element.areaInformationName = ary[ary.length - 1];
						// });
						this.list = res.objects;
					}
					this.loading = false;
				});
			},
			connectLists() {
				this.loading = true;
				var orgID = this.$app == "dy" ? 461 : 559
				getShopLists(this.page, orgID).then((res) => {
					this.list = [];
					if (res.objects != null) {
						// res.objects.forEach((element) => {
						// 	let ary = element.areaInformationName.split("-");
						// 	element.areaInformationName = ary[ary.length - 1];
						// });
						this.list = res.objects;
					}
					this.loading = false;
				});
			},
		},
	};
</script>

<style lang="less">
	.shop-total {
		display: flex;
		align-items: center;
		flex-direction: column;
		position: relative;
		width: 100%;
		background-color: #fceee5;

		.containers {
			display: flex;
			align-items: center;
			flex-direction: column;
			z-index: 22;
			margin-top: 280px;
			padding-bottom: 20px;
			box-sizing: border-box;
		}

		.bottom {
			display: flex;
			margin-top: 53px;
			// position: absolute;
			// top: 1370px;

			.last-btn {
				width: 179px;
				height: 58px;
				margin-right: 25px;
			}

			.next-btn {
				margin-left: 25px;
				width: 179px;
				height: 58px;
			}
		}

		.bg {
			width: 100%;
			position: absolute;
			top: 0;
			z-index: 1;
		}

		.content {
			display: flex;
			flex-direction: column;
			// position: absolute;
			// top: 281px;
			width: 1200px;
			background: #ffffff;
			align-items: center;
			border-radius: 30px;

			.tab {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				// padding: 20px;
				// box-sizing: border-box;
			}

			.tabs {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 2;
			}

			.tabs label {
				flex: 1;
				height: 80px;
			}

			.tab img {
				width: 100%;
			}

			.listConOne {
				width: 100%;
				padding: 28px 40px;
				box-sizing: border-box;

				.item {
					display: flex;
					flex: 1;
					background: #F6F9FA;
					border: 1px dashed #D2D6DB;
					margin-bottom: 14px;

					.itemLon {
						display: flex;
						flex-direction: column;
						flex: 1;
						padding: 0 17px;
						box-sizing: border-box;
					}


					.itemLon-one {
						display: flex;
						align-items: center;
						border-bottom: 1px dashed #DCDCDC;
						font-size: 18px;
						color: #333333;
						box-sizing: border-box;
						font-weight: bold;
					}
				}
			}

			.listCon {
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				gap: 16px;
				width: 100%;
				padding: 28px 40px;
				box-sizing: border-box;

				.item {
					display: flex;
					flex: 1;
					background: #F6F9FA;
					border: 1px dashed #D2D6DB;

					.itemLon {
						display: flex;
						align-items: center;
						flex: 1;
						padding: 0 17px;
						box-sizing: border-box;

						.itemLon-one {
							display: flex;
							align-items: center;
							font-size: 18px;
							color: #333333;
							box-sizing: border-box;
							font-weight: bold;
							width: 100%;
						}
					}

				}
			}

		}
	}

	.icon1 {
		width: 24px;
		height: 24px;
		margin-right: 9px;
	}

	.itemLon-show,
	.banner {
		width: 94px;
		height: 132px;
		background-color: #D2D6DB;
	}

	.address {
		display: flex;
		align-items: center;
		width: 100%;
		padding-top: 22px;
		box-sizing: border-box;
	}

	.line {
		padding: 0 10px;
		box-sizing: border-box;
	}
</style>